import { Card, Col, Spin, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { useFollowUps } from "../../hooks/useFollowUp";
import FollowUpItem from "./FollowUpItem";

const { Title, Text } = Typography;


const FollowUpsCard = () => {
const navigate = useNavigate();

const { followUps, loading } = useFollowUps(5);

  return (
    <Col xs={24} md={24} lg={12}>
      <Card
        style={{
          background: "rgba(88, 80, 109, 0.30)",
          borderRadius: 16,
          height: "100%",
        }}
      >
        {/* Follow-ups content */}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 16,
          }}
        >
          <Title level={5} style={{ color: "#fff" }}>
            Follow-ups
          </Title>

           <Text style={{ color: "#a855f7", cursor: "pointer" }} onClick={() => navigate('/follow-ups')}>
          View All →
        </Text>
        </div>

        <div>
          {loading ? (
            <Spin/>
          ) : (
            followUps.map((item, index) => (
              <FollowUpItem item={item} index={index} key={index} />
            ))
          )}
        </div>
      </Card>
    </Col>
  );
};

export default FollowUpsCard;
